import React, { ReactNode, useRef, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { QuestionCircle } from "react-bootstrap-icons";
import { Placement } from "react-bootstrap/esm/types";

export interface IPopoverBtnProps {
  text: ReactNode | string;
  icon?: ReactNode;
  className?: string;
  error?: boolean;
  placement?: Placement;
  tooltipWidth?: string | number;
}

export default function PopoverBtn({
  text,
  icon = <QuestionCircle />,
  className = "",
  error = false,
  placement = "auto",
  tooltipWidth,
}: IPopoverBtnProps) {
  const isMobile = window.innerWidth <= 768;
  const [show, setShow] = useState(false);
  const hideTimeout = useRef<ReturnType<typeof setTimeout> | null>(null);

  const handleShow = () => {
    if (hideTimeout.current) clearTimeout(hideTimeout.current);
    setShow(true);
  };

  const handleHide = () => {
    hideTimeout.current = setTimeout(() => setShow(false), 150);
  };

  return (
    <>
      {(text || error) && (
        <OverlayTrigger
          show={show}
          container={document.body}
          placement={
            isMobile ? "top" : placement !== "auto" ? placement : "right"
          }
          overlay={
            <Tooltip
              style={{
                width: tooltipWidth ? tooltipWidth : "auto",
                maxWidth: "none",
              }}
              onMouseEnter={handleShow}
              onMouseLeave={handleHide}
            >
              {text}
            </Tooltip>
          }
          popperConfig={{
            modifiers: [
              { name: "flip", enabled: true },
              { name: "preventOverflow", enabled: true },
            ],
          }}
        >
          <div
            className={className}
            onClick={(e) => e.stopPropagation()}
            onMouseEnter={handleShow}
            onMouseLeave={handleHide}
          >
            {icon}
          </div>
        </OverlayTrigger>
      )}
    </>
  );
}
